import api from './apiconfig.js';
/**
 * Tables API Service
 * Handles table management operations
 */

const API_BASE_URL = api.API_BASE; // Update with your backend URL

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` })
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Network error' }));
    throw new Error(error.message || `HTTP ${response.status}`);
  }
  return response.json();
};

export const fetchTables = async () => {
  const response = await fetch(`${API_BASE_URL}/tables`, {
    headers: getAuthHeaders()
  });
  const data = await handleResponse(response);
  return data;
};

export const createTable = async (tableData) => {
  const response = await fetch(`${API_BASE_URL}/tables`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(tableData)
  });
  const data = await handleResponse(response);
  return data;
};

export const updateTable = async (tableId, tableData) => {
  const response = await fetch(`${API_BASE_URL}/tables/${tableId}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(tableData)
  });
  const data = await handleResponse(response);
  return data;
};

export const deleteTable = async (tableId) => {
  const response = await fetch(`${API_BASE_URL}/tables/${tableId}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  const data = await handleResponse(response);
  return data;
};

export const activateTable = async (tableId) => {
  const response = await fetch(`${API_BASE_URL}/tables/${tableId}/activate`, {
    method: 'PATCH',
    headers: getAuthHeaders()
  });
  const data = await handleResponse(response);
  return data;
};

export const deactivateTable = async (tableId) => {
  const response = await fetch(`${API_BASE_URL}/tables/${tableId}/deactivate`, {
    method: 'PATCH',
    headers: getAuthHeaders()
  });
  const data = await handleResponse(response);
  return data;
};